export default "__VITE_ASSET__BmUnrrLG__"